import { Box, textAlign } from "@mui/system";
import { Image, Row } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import Adjuntar from "../../Img/Iconos/AdjuntarArchivo.svg";
import Eliminar from "../../Img/Iconos/eliminar.svg";
import Icono from "../IconosDeSitio";
import {
  Checkbox,
  Divider,
  Tooltip,
  Typography,
  FormControlLabel,
  Badge
} from '@mui/material';
import {
  OndemandVideo,
  PictureAsPdf as PictureAsPdfIcon,
  AttachFile as AttachFileIcon
} from "@mui/icons-material";
import { FileWordOutlined } from "@ant-design/icons";
import PreviewImage from "./previewImage";
import Alert from '@mui/material/Alert';

const badgeStyle = {
  '& .MuiBadge-badge': {
    backgroundColor: '#148F9F',
    color: '#fff',
  },
};

export default function InputFileList({ arrayImg, extras, formatos, valueArrayImg, deleteFiles, activeChecks=false }) {
  // console.log(valueArrayImg);
  // subir Archivos lista
  const [OpenArchivo, setOpenArchivo] = useState(1);
  const [Formatos, setFormatos] = useState(formatos);
  const [UrlImg, setUrlImg] = useState(valueArrayImg !== undefined ? valueArrayImg.length > 0 ? valueArrayImg : [] : []);
  const [returnFor, setReturnFor] = useState(false);
  const handleModalContainerClick = e => e.stopPropagation();
  const [TotalMegas, setTotalMegas] = useState(0);
  const [forDelete, setForDelete] = useState([]);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if(valueArrayImg) {
      setUrlImg(valueArrayImg);
    }
  }, [valueArrayImg]);

  function addImagesToArray(e) {
    // console.log(Formatos);
    //esto es el indice que se le dará a cada imagen, a partir del indice de la ultima foto
    let indexImg = valueArrayImg.length > 0 ? valueArrayImg[valueArrayImg.length - 1].index + 1 : 0;
    //aquí evaluamos si ya hay imagenes antes de este input, para saber en dónde debe empezar el index del proximo array
    let array_files = e.currentTarget.files;
    let total_temp = 0;
    if (Array.from(e.currentTarget.files).length > 20) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
    }

    const files = Array.from(e.currentTarget.files).slice(0, 20);

    Object.keys(files).forEach(x => {
      // console.log(array_files[x].size);
      total_temp += array_files[x].size;
    });

    if (total_temp <= 20000000) {

      //el array con las imagenes nuevas
      const arrayImages = [];

      Object.keys(files).forEach((i) => {
        const file = files[i];
        // console.log("FOR EACH fuera" + i);
        let url = URL.createObjectURL(file);
        let formato = file.type.split("/");
        // console.log(file.type);
        let fileSize = ((file.size / 1024) / 1024);
        if (formato[1] === "pdf" || formato[1] === "jpeg" || formato[1] === "png" || formato[1] === "doc" || formato[1] === "docx"
          || formato[1] === "msword" || formato[1] === "vnd.openxmlformats-officedocument.wordprocessingml.document" || formato[1] === "jpg") {
          if (fileSize <= 6) {
            // if (UrlImg.length > 0) {
            //   indexImg = UrlImg[UrlImg.length - 1].index + 1;
            // } else {
            //   indexImg = 0;
            // }

            arrayImages.push({
              index: indexImg,
              name: file.name,
              url,
              file,
              size: file.size,
              formato: formato[1],
              tipo: "0",
              sendToPatient: true,
            });

            let newImgsState = [...valueArrayImg, ...arrayImages];
            let newImgsStateCopy = [];
            if (newImgsState.length>20) {
              newImgsStateCopy = newImgsState.slice(0, 20);
              newImgsState = newImgsStateCopy;
            }

            indexImg++;

            if (extras[3] !== undefined) {
              extras[3](newImgsState);
            }

            setUrlImg(newImgsState);
            arrayImg(newImgsState);
            // document.getElementById("FileArchivo").value = "";
            let total = TotalMegas + fileSize;
            setTotalMegas(total);
            // console.log(newImgsState);
          } else {
            if (extras !== undefined) {
              extras[0](true);
              extras[1]("warning");
              extras[2]("El archivo excede el tamaño maximo permitido (6MB)");
            }
          }

        } else {
          if (formato[0] === "video") {
            if (fileSize <= 10) {
              // if (UrlImg.length > 0) {
              //   indexImg = UrlImg[UrlImg.length - 1].index + 1;
              // } else {
              //   indexImg = 0;
              // }

              arrayImages.push({
                index: indexImg,
                name: file.name,
                url,
                file,
                size: file.size,
                formato: formato[1],
                tipo: "0",
                sendToPatient: true,
              });

              let newImgsState = [...valueArrayImg, ...arrayImages];
              let newImgsStateCopy = [];
              if (newImgsState.length>20) {
                newImgsStateCopy = newImgsState.slice(0, 20);
                newImgsState = newImgsStateCopy;
              }
              indexImg++;

              if (extras[3] !== undefined) {
                extras[3](newImgsState);
              }

              setUrlImg(newImgsState);
              arrayImg(newImgsState);
              // document.getElementById("FileArchivo").value = "";
              let total = TotalMegas + fileSize;
              setTotalMegas(total);

            } else {
              if (extras !== undefined) {
                extras[0](true);
                extras[1]("warning");
                extras[2]("El video excede el tamaño maximo permitido (10MB)");
              }
              // document.getElementById("FileArchivo").value = "";
            }
          } else {

            extras[0](true);
            extras[1]("warning");
            if (formatos === 1) {
              // console.log("1");
              extras[2]("Tipo de archivo no valido. Archivos permitidos: imagenes ( png, jpeg )");
            } else if (formatos === 2) {
              // console.log("2");
              extras[2]("Tipo de archivo no valido. Archivos permitidos: videos");
            } else if (formatos === 3) {
              // console.log("3");
              extras[2]("Tipo de archivo no valido. Archivos permitidos: archivos (pdf)");
            } else if (formatos === 4) {
              // console.log("4");
              extras[2]("Tipo de archivo no valido. Archivos permitidos: imagenes y archivos ( png, jpeg, pdf )");
            } else if (formatos === 5 || formatos === undefined) {
              // console.log("4");
              extras[2]("Tipo de archivo no valido. Archivos permitidos: imagenes, archivos y videos ( png, jpeg, pdf, doc, docx )");
            }
          }
        }
      });
    } else {
      extras[0](true);
      extras[1]("warning");
      extras[2]("El listado de archivos excede el tamaño maximo permitido (20MB)");
    }
    document.getElementById("FileArchivoList").value = "";
  }

  function deleteImg(index) {
    const newImgs = valueArrayImg.filter(function (element) {
      return element.index !== index;
    });

    if (newImgs.length === 0) {
      document.getElementById("FileArchivoList").value = "";
    }

    setUrlImg(newImgs);
    arrayImg(newImgs);
    let forRemove = forDelete;
    forRemove.push(valueArrayImg[index].id);
    deleteFiles(forRemove);
    return;
  };

  function selectFormato() {
    const Imagenes = {
      input: "image/png,image/jpeg",
      validacion: ["png", "jpeg"]
    };
    const Videos = {
      input: "video/*",
      validacion: []
    };
    const Pdf = {
      input: "application/pdf",
      validacion: ["pdf"]
    };
    const Archivos = {
      input: "image/png,image/jpeg,application/pdf",
      validacion: ["png", "jpeg", "pdf"]
    }
    const Todos = {
      input: ".doc,.docx,image/png,image/jpeg,application/pdf,video/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      validacion: ["png", "jpeg", "pdf", "doc", "docx", "msword", "vnd.openxmlformats-officedocument.wordprocessingml.document"]
    }

    if (formatos === 1) {
      return Imagenes.input;
    } else if (formatos === 2) {
      return Videos.input;
    } else if (formatos === 3) {
      return Pdf.input;
    } else if (formatos === 4) {
      return Archivos.input;
    } else if (formatos === 5 || formatos === undefined) {
      return Todos.input;
    }
  }

  const handleCheckboxChange = (event, index) => {
    const newArray = [...UrlImg];
    newArray[index].sendToPatient = event.target.checked;
    setUrlImg(newArray);
  };

  const handleCheckAll = (event)=>{
    const copyUrlImage = [...UrlImg];
    copyUrlImage.map((file) => {
      file.sendToPatient = event.target.checked;
    });
    setUrlImg(copyUrlImage);
  };

  return (
    <>
      {
      showAlert ? (
        <Alert severity="warning" sx={{ marginBottom: '15px' }}>
          <Typography sx={{ display: 'flex', justifyContent: 'center' }}>
            Solo se permiten máximo 20 archivos.
          </Typography>
        </Alert>
        ) : null
      }
      <label htmlFor="FileArchivoList" style={{ cursor: "pointer", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <AttachFileIcon fontSize='small' sx={{ fileSize: '14px' }} />
        <b>Adjuntar</b>
        <input
          hidden={true}
          id="FileArchivoList"
          type="file"
          accept={`${selectFormato}`}
          onChange={(e) => {
            setReturnFor(false);
            addImagesToArray(e);
          }}
          style={{ display: "none" }}
          multiple
        />
      </label>
      <br />
      <br />
      {OpenArchivo === 0 ? (
        <div>
          <p>Aun no se agregan archivos</p>
        </div>
      ) : (
        <div>
          <Row
          style={{ justifyContent: "end", cursor: "pointer", alignItems: "center", paddingRight: '12px' }}
          onClick={() => { }}
          >
            { OpenArchivo === 1 && UrlImg.length > 0 && activeChecks && <FormControlLabel control={<Checkbox defaultChecked onChange={(e)=>handleCheckAll(e)} />} labelPlacement="start" label="Seleccionar todos" />}
          </Row>
          {OpenArchivo === 1 &&
            UrlImg.map((imagen, index) => (
              <Row style={{ justifyContent: "space-between", padding: activeChecks ? 1 :  "1% 3%", border: "1px solid #d7d7d7", margin: "10px 0" }} key={index}>
                {
                  (imagen.formato === "png" || imagen.formato === "jpeg" || imagen.formato === "jpg") ?
                    (
                      <Row
                        style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: activeChecks ? "80%" : "90%" }}

                      >
                        <Badge badgeContent={index + 1}   sx={badgeStyle}>
                          <PreviewImage urlImage={imagen.url} style={{ width: "50px", height: "50px" }} imageName={imagen.name} />
                        </Badge>

                        <div onClick={() => { window.open(imagen.url, "_blank") }} style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                          <span>{imagen.name}</span>
                        </div>
                        <div >
                          {!!imagen.size && `${(imagen.size / 1000000).toFixed(2)} MB`}
                        </div>
                      </Row>
                    ) : imagen.formato === "pdf" ?
                      (
                        <Row
                          style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: activeChecks ? "80%" : "90%" }}
                          onClick={() => { window.open(imagen.url, "_blank") }}
                        >
                          <Badge badgeContent={index + 1}   sx={badgeStyle}>
                            <PictureAsPdfIcon sx={{ color: '#cb5959', fontSize: '45px' }} />
                          </Badge>
                          <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                            <span>{imagen.name}</span>
                          </div>
                          <div>
                            {!!imagen.size && `${(imagen.size / 1000000).toFixed(2)} MB`}
                          </div>
                        </Row>
                      ) : (imagen.formato === "doc" || imagen.formato === "docx" || imagen.formato === "msword" || imagen.formato === "vnd.openxmlformats-officedocument.wordprocessingml.document") ? (
                        <Row
                          style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: activeChecks ? "80%" : "90%" }}
                          onClick={() => { window.open(imagen.url, "_blank") }}
                        >
                          <Badge badgeContent={index + 1}   sx={badgeStyle}>
                            <FileWordOutlined style={{ fontSize: "45px", color: "#148F9F" }} />
                          </Badge>
                          <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                            <span>{imagen.name}</span>
                          </div>
                          <div>
                            {!!imagen.size && `${(imagen.size / 1000000).toFixed(2)} MB`}
                          </div>
                        </Row>
                      ) :
                        (
                          <Row
                            style={{ justifyContent: "space-between", cursor: "pointer", alignItems: "center", width: activeChecks ? "80%" : "90%" }}
                            onClick={() => { window.open(imagen.url, "_blank") }}
                          >
                            <Badge badgeContent={index + 1}   sx={badgeStyle}>
                              <OndemandVideo sx={{ color: "#148F9F", fontSize: "45px" }} />
                            </Badge>
                            <div style={{ width: "40%", height: "20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                              <span>{imagen.name}</span>
                            </div>
                            <div>
                              {!!imagen.size && `${(imagen.size / 1000000).toFixed(2)} MB`}
                            </div>
                          </Row>
                        )
                }
                <Box sx={{ display: "flex"}}>
                  { activeChecks ? ( <Divider orientation="vertical" flexItem />) : null }
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: '44px' }}>
                    <img
                      style={{ width: "18px", cursor: "pointer" }}
                      onClick={() => { deleteImg(imagen.index); }}
                      src={Eliminar}
                      alt=""
                    />
                  </div>
                  {
                    activeChecks ? (
                      <>
                        <Divider orientation="vertical" flexItem />
                        <Tooltip title={<Typography sx={{ fontSize: '15px' }}>
                            Check para enviar al paciente.
                          </Typography>} placement="right">
                          <Checkbox
                            checked={imagen.sendToPatient}
                            onChange={(e)=>handleCheckboxChange(e, index)}
                            inputProps={{ 'aria-label': 'controlled' }}
                          />
                        </Tooltip>
                      </>
                    ) : null
                  }
                </Box>
              </Row>
            ))}
        </div>
      )}
    </>
  );
}
